import React from 'react'
import Wrapper from './style'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

const SchLoading = () => {
	return (
		<Wrapper>
			<FontAwesomeIcon
				icon={faCircleNotch}
				spin
				fixedWidth
			/>
			Loading
		</Wrapper>
	)
}

export default SchLoading
